/* tslint:disable */
import {
  GeoPoint
} from '../index';

declare var Object: any;
export interface DeliveryAddressInterface {
  "handleId"?: string;
  "name": string;
  "address": any;
  "location"?: GeoPoint;
  "isDefault"?: boolean;
  "isBilling"?: boolean;
  "id"?: number;
}

export class DeliveryAddress implements DeliveryAddressInterface {
  "handleId": string;
  "name": string;
  "address": any;
  "location": GeoPoint;
  "isDefault": boolean;
  "isBilling": boolean;
  "id": number;
  constructor(data?: DeliveryAddressInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DeliveryAddress`.
   */
  public static getModelName() {
    return "DeliveryAddress";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DeliveryAddress for dynamic purposes.
  **/
  public static factory(data: DeliveryAddressInterface): DeliveryAddress{
    return new DeliveryAddress(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DeliveryAddress',
      plural: 'deliveryAddresses',
      path: 'deliveryAddresses',
      idName: 'id',
      properties: {
        "handleId": {
          name: 'handleId',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "address": {
          name: 'address',
          type: 'any'
        },
        "location": {
          name: 'location',
          type: 'GeoPoint'
        },
        "isDefault": {
          name: 'isDefault',
          type: 'boolean'
        },
        "isBilling": {
          name: 'isBilling',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
